<template>
  <BaseEmptyState>
    <template v-slot:icon>
      <EnvelopeIcon />
    </template>
    <template v-slot:title>
      <h2>{{ $t('ui.envelopes.emptyState.noEnvelopes.title') }}</h2>
    </template>
    <template v-slot:content>
      <p>
        {{ $t('contactStatus.noEnvelopesFoundForContact') }}
      </p>
    </template>
  </BaseEmptyState>
</template>

<script>
import { EnvelopeIcon } from '@/components/icons/fontIcons';
import BaseEmptyState from '@/components/library/emptyStates/BaseEmptyState.vue';

export default {
  name: 'NoEnvelopesForContactEmptyState',
  components: {
    BaseEmptyState,
    EnvelopeIcon,
  },
};
</script>
